const WelcomeBlock = ({ copy }) => {
    return (
        <div className="mb__welcome-block">
            <h1>{copy.heading}</h1>
        </div>
    );
};

export default WelcomeBlock;